<template lang="pug">
  .pdp-bottom
    social-share(v-if="!$rogue.appContext" :productId='product.productId')
    .bottom
      ProductCarousel.recommendations(
        v-if="!product.attributes.hide_rfk_pdp_widgets && similarItemsReady"
        :widget="widgets.PRODUCTS_SIMILAR"
        :key="'reco-'+product.productId"
        title="Similar Items"
        :podId="PODS.SIMILAR_ITEMS"
        :itemIds="[String(product.productId)]"
        :filterGroupIds="filterGroupIds"
      )
      ProductCarousel.recommendations(
        v-if="!product.attributes.hide_rfk_pdp_widgets"
        :widget="widgets.PRODUCTS_FOR_YOU"
        title="Recommended Products"
        :lazy="true"
        :podId="PODS.RECOMMENDED_PRODUCTS"
        :itemIds="[String(product.productId)]"
      )
      reviews( v-if="!product.attributes.rogue_bvcon_hidereviews" :key="'reviews-'+product.productId" :product='product' )
      curations.curations(:product='product')
</template>

<script setup lang="ts">
import { computed } from 'vue'
import Curations from './components/curations.vue'
import Reviews from './components/reviews.vue'
import SocialShare from '@/js/components/social-share.vue'
import { widgets } from '@/js/services/rfk/types'
import { useCategoryStore } from '@/js/stores/categoryStore'
import { PODS } from '@/js/services/cnstrc/constants'
import type { Product } from '@/js/services/RogueTypes'

const props = defineProps<{ product: Product }>()

const categoryStore = useCategoryStore()

const primaryCategory = computed(() => categoryStore.categories?.[props.product.primaryCategoryId])

const filterGroupIds = computed<string[]>(() => {
  const ids = [String(props.product.primaryCategoryId)]
  const parentId = primaryCategory.value?.path.at(-1)?.categoryId
  if (parentId) {
    ids.push(String(parentId))
  }

  return ids
})

// Don't render the Similar Items carousel until the category is loaded so
// filterGroupIds is stable and ProductList makes exactly one API call.
const similarItemsReady = computed<boolean>(() => !!primaryCategory.value)
</script>

<style lang="scss" scoped>

.recommendations, .curations {
  margin-bottom: $space-xxl;

  @media(min-width: $desktop) {
    margin-bottom: 96px;
  }
}

.curations {
  max-width: 100%;
}

.bottom {
  display: flex;
  flex-direction: column;
}
</style>
